import { PublicProvider } from '../../api/Providers';
import { isAnonymous, ShareUser } from '../share';

export const generatePlatformMessage = (user: ShareUser, trackingId: any) => {
  const loggedInUser = isAnonymous(user) ? null : user;
  return {
    title: loggedInUser?.first_name ? `${loggedInUser.first_name} is giving you up to $50 off to try out StyleSeat` : 'I want to give you up to $50 off to try out StyleSeat',
    text: 'Book on StyleSeat and get up to $50 off your first appointment.\n\nYou can explore hundreds of other services and manage your appointments from the StyleSeat app.\n\n',
    urlParams: [
      { key: 'ncd_source', value: 'client_referral' },
      // Need to conditionally attach this, as a null value
      // will break the request to the sharing_links endpoint
      ...(loggedInUser?.user_id ? [{ key: 'user_id_referrer', value: loggedInUser?.user_id }] : []),
      { key: 'referral_id', value: trackingId },
    ],
  };
};

export const makeProfileMessageGenerator = (
  profile: Pick<PublicProvider, 'name' | 'id'>,
) => (
  user: ShareUser,
  trackingId: any,
) => {
  const loggedInUser = isAnonymous(user) ? null : user;
  return {
    title: loggedInUser?.first_name ? `${loggedInUser.first_name} is giving you up to $50 off to try out their stylist on StyleSeat` : 'I want to give you up to $50 off to try out my stylist on StyleSeat',
    text: `I'd love to refer my stylist, ${profile.name} to you! Book them on StyleSeat and get up to $50 off your first appointment.\n\nPlus, you can explore hundreds of other services and manage your appointments from the StyleSeat app.\n\n`,
    urlParams: [
      { key: 'ncd_source', value: 'client_referral' },
      { key: 'ncd_term', value: profile.id },
      // Need to conditionally attach this, as a null value
      // will break the request to the sharing_links endpoint
      ...(loggedInUser?.user_id ? [{ key: 'user_id_referrer', value: loggedInUser?.user_id }] : []),
      { key: 'referral_id', value: trackingId },
    ],
  };
};
